<template>
  <div
    class="h-14 bg-indigo-800 text-white flex justify-center flex-col text-center leading-tight z-50 cursor-pointer"
    @click="onClick"
  >
    <div class="text-md xl:text-xl">
      <text-semi-bold>Book an Appointment</text-semi-bold> or call
      <text-semi-bold
        ><a :href="`tel:{{ phoneNumber }}`">{{
          phoneNumber
        }}</a></text-semi-bold
      >
    </div>
    <div>Accepting all major insurers</div>
  </div>
</template>

<script setup>
defineProps({
  phoneNumber: {
    type: String,
    required: true,
  },
  onClick: {
    type: Function,
    default: () => {},
  },
});
</script>
